<template>
  <ul class="topnav-links-container">
    <li v-for="link in limitedLinks" :key="link.text">
      <a :href="link.url" v-html="link.text" />
    </li>
  </ul>
</template>

<script>
import Vue from "vue";
import VueMq from "vue-mq";

Vue.use(VueMq, {
  breakpoints: {
    mobile: 375,
    phablet: 768,
    tablet: 1024,
    desktop: 1440,
    desktopHD: Infinity
  }
});

export default {
  name: "NsTopnavLinkList",
  props: {
    links: {
      type: [Array, String, undefined],
      default: JSON.stringify("[]")
    }
  },
  data: function() {
    return {
      localLinks: []
    };
  },
  computed: {
    limitedLinks() {
      return this.localLinks.slice(0, 4).filter(link => !!link.text);
    }
  },
  watch: {
    links: {
      immediate: true,
      handler(newVal) {
        this.localLinks = [];
        if (newVal) {
          if (typeof newVal === "string") {
            const newValJson = JSON.parse(newVal) || [];
            if (typeof newValJson === "string") {
              this.localLinks = JSON.parse(newValJson) || [];
            } else {
              this.localLinks = newValJson;
            }
          } else {
            this.localLinks = [...newVal];
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.topnav-links-container {
  margin-top: 30px;
  margin-left: 113px;
  width: 15.56vw;
  max-width: 210px;
  min-width: 110px;
  list-style: none;

  li {
    padding: 6px 0;
    font-size: 15px;
    font-weight: var(--font-weight-semibold);
    letter-spacing: 0px;
    line-height: normal;
    color: inherit;
    transition: var(--global-transition);

    a {
      font-family: var(--font-family-primary);
      color: var(--color-interactive-7);
      text-decoration: none !important;
      border-bottom: 1px solid transparent;
      transition: var(--global-transition);

      &:link,
      &:visited {
        color: var(--color-interactive-7);
      }
    }

    &:hover a {
      border-bottom: 1px solid currentColor;
    }
  }
}

@media (max-width: 1023px) {
  .topnav-links-container {
    margin: 0;
    width: 100%;
    height: auto;
    max-width: unset;
    min-width: unset;

    li {
      margin: 0;
      padding: 0;
      color: var(--color-interactive-8);

      a {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        min-height: 45px;
        padding: 10px 15px 10px 30px;
        border-bottom: none;
        color: var(--color-interactive-8);
        font-size: 18px;
        font-weight: 300;
        line-height: normal;

        &:link,
        &:visited {
          color: var(--color-interactive-8);
        }
      }

      &:hover a {
        border-bottom: none;
      }

      &:first-child {
        margin-bottom: 50px;

        a {
          color: var(--color-interactive-7);
          font-weight: normal;
        }
      }
    }
  }
}
</style>
